
export default function Header() {
    return (
        <header>
            <h2 className="h2--header">Meme Generator</h2>

            <h4 className="h4--header">React course - project</h4>
        </header>
    )
}